import { createContext, useContext, useEffect, useState } from "react";

const SlipCtx = createContext(null);

export function BetSlipProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("pp_slip") || "[]"));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("pp_slip", JSON.stringify(items));
  }, [items]);

  const toggle = (ev, pick) => {
    setItems((prev) => {
      const same = prev.find((s) => s.event.id === ev.id && s.pick === pick);
      if (same) return prev.filter((s) => s !== same);
      const rest = prev.filter((s) => s.event.id !== ev.id);
      return [...rest, { event: ev, pick, odds: ev.odds[pick] }];
    });
  };
  const isSelected = (eid, pick) => items.some((s) => s.event.id === eid && s.pick === pick);
  const remove = (eid) => setItems((p) => p.filter((s) => s.event.id !== eid));
  const clear = () => setItems([]);
  const updateOdds = (changes) =>
    setItems((p) =>
      p.map((s) => {
        const c = changes.find((x) => x.event_id === s.event.id && x.pick === s.pick);
        return c ? { ...s, odds: c.odds, changed: true } : s;
      })
    );

  return (
    <SlipCtx.Provider value={{ items, toggle, isSelected, remove, clear, updateOdds, open, setOpen }}>
      {children}
    </SlipCtx.Provider>
  );
}

export const useSlip = () => useContext(SlipCtx);
